import {
    setCookieOrWebStorage
} from '../global/_cookies';

export const allDevicesCaptureCachedState = () => {
    // currentState.stateManager(); // get current state
    // cachedState = {
    //     cachedBreakpoint: currentState.breakpoint,
    //     cachedOrientation: currentState.orientation,
    //     cachedTouch: currentState.touch
    // }
    // setCookieOrWebStorage("sessionStorage", "cachedStateSession", JSON.stringify(cachedState));
};
